import DistrictLocationList from '@/views/district-locations/DistrictLocationList.vue';
import DistrictLocationDetails from '@/views/district-locations/DistrictLocationDetails.vue';
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

import ServiceList from "@/views/services/ServiceList.vue";
import TollList from "@/views/services/TollList.vue";
import TollCreate from '@/views/services/TollCreate.vue';
import TollEdit from '@/views/services/TollEdit.vue';

import LocationList from '@/views/locations/LocationList.vue';
import LocationDetails from '@/views/locations/LocationDetails.vue';

import PassengerList from "@/views/passenger/PassengerList.vue";
import PassengerDetails from "@/views/passenger/PassengerDetails.vue";
import PassengerImportList from "@/views/passenger-import/PassengerImportList.vue";
import PassengerImportDetails from "@/views/passenger-import/PassengerImportDetails.vue";

import CustomerList from "@/views/customer/CustomerList.vue";
import CustomerDetails from "@/views/customer/CustomerDetails.vue";

import RequesterList from "@/views/requester/RequesterList.vue";
import RequesterDetails from "@/views/requester/RequesterDetails.vue";

import PreventiveList from "@/views/maintenance/PreventiveList.vue";
import PreventiveMaintenanceDetails from "@/views/maintenance/PreventiveMaintenanceDetails.vue";
import CorrectiveList from "@/views/maintenance/CorrectiveList.vue";
import CorrectiveDetails from "@/views/maintenance/CorrectiveDetails.vue";
import PreventiveSchedulingList from "@/views/maintenance/PreventiveSchedulingList.vue";
import PreventiveSchedulingDetails from "@/views/maintenance/PreventiveSchedulingDetails.vue";
import PartStockList from "@/views/maintenance/PartStockList.vue";
import PartStockDetails from "@/views/maintenance/PartStockDetails.vue";
import SupplierList from "@/views/maintenance/SupplierList.vue";
import SupplierDetails from "@/views/maintenance/SupplierDetails.vue";

import VehicleList from "@/views/vehicle/VehicleList.vue";
import VehicleDetails from "@/views/vehicle/VehicleDetails.vue";
import VehicleCatalog from "@/views/vehicle/VehicleCatalog.vue";

import LogisticsList from "@/views/logistics/LogisticsList.vue";
import LogisticsImport from "@/views/logistics/LogisticsImport.vue";

import DriverList from "@/views/drivers/DriverList.vue";
import DriverDetails from "@/views/drivers/DriverDetails.vue";

import AdminList from "@/views/administrator/AdminList.vue";
import AdminDetails from "@/views/administrator/AdminDetails.vue";

import ItineraryList from "@/views/itinerary/ItineraryList.vue";
import ItineraryDetails from "@/views/itinerary/ItineraryDetails.vue";

import IntervalList from "@/views/intervals/IntervalList.vue";
import IntervalDetails from "@/views/intervals/IntervalDetails.vue";

import HolidaysList from "@/views/holidays/HolidaysList.vue";
import HolidaysDetails from "@/views/holidays/HolidaysDetails.vue";

import RolesList from "@/views/roles/RolesList.vue";
import RolesDetails from "@/views/roles/RolesDetails.vue";

import SuppliesList from "@/views/supplies/SuppliesList.vue";
import SuppliesDetails from "@/views/supplies/SuppliesDetails.vue";

import CostCenterList from "@/views/cost-center/CostCenterList.vue";
import CostCenterDetails from "@/views/cost-center/CostCenterDetails.vue";

import TripRecurrenceList from "@/views/trips/TripRecurrenceList.vue";

import AuditList from "@/views/audit/AuditList.vue";
import AdminNotificationList from "@/views/notifications/AdminNotificationList.vue";

import FinancialDashboard from "@/views/financial/FinancialDashboard.vue";
import DriverPayoutsOverview from "@/views/financial/DriverPayoutsOverview.vue";
import DriverPayoutDetails from "@/views/financial/DriverPayoutDetails.vue";
import VehicleCostsOverview from "@/views/financial/VehicleCostsOverview.vue";
import VehicleCostDetails from "@/views/financial/VehicleCostDetails.vue";
import ExpenseList from "@/views/financial/ExpenseList.vue";
import FinancialRevenue from "@/views/financial/FinancialRevenue.vue";
import FinancialDre from "@/views/financial/FinancialDre.vue";

import * as jwt from "jwt-decode";
import TripRecurrenceDetails from "@/views/trips/TripRecurrenceDetails.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";

const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );

  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/login",
    });
    return;
  }

  if (to.name == "Home") {
    next();
    return;
  }

  const resolvedToken = jwt(token);
  const user = resolvedToken.data;

  const permissions = to.meta.permissions;

  console.log('permissions ', permissions)

  if (!permissions || !permissions.length) {
    next();
    return
  }

  console.log('user roles ', user)

  if (!user || !user.role || !user.role.permissions) {
    next({
      path: "/home",
    });
    return;
  }

  const userPermissions = user.role.permissions.map((item: any) => item.permission.key);

  if (userPermissions.includes("*")) {
    next();
    return;
  };

  const hasPermission = permissions.some((permission) => {
    return (
      userPermissions.includes(permission) ||
      userPermissions.includes(permission + ".*") ||
      userPermissions.includes(permission.split(".")[0] + ".*")
    );
  });

  if (!hasPermission) {
    next({
      path: "/home",
    });
    return;
  }

  next();
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/", component: () => import("@/layouts/Public.vue"),
    children: [
      { path: "/login", name: "login", component: Login, },
      { path: "/politica-de-privacidade", name: "privacy-policy", component: PrivacyPolicy, },
      { path: "/", redirect: "/login", },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
      },

      {
        path: "/notificacoes",
        name: "AdminNotificationList",
        component: AdminNotificationList,
        beforeEnter: guard,
      },

      {
        path: "/financeiro",
        name: "FinancialDashboard",
        component: FinancialDashboard,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/motoristas",
        name: "DriverPayoutsOverview",
        component: DriverPayoutsOverview,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/receitas",
        name: "FinancialRevenue",
        component: FinancialRevenue,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/dre",
        name: "FinancialDre",
        component: FinancialDre,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/despesas",
        name: "ExpenseList",
        component: ExpenseList,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/veiculos",
        name: "VehicleCostsOverview",
        component: VehicleCostsOverview,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/veiculos/:id",
        name: "VehicleCostDetails",
        component: VehicleCostDetails,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/financeiro/motoristas/fechamentos/:id",
        name: "DriverPayoutDetails",
        component: DriverPayoutDetails,
        beforeEnter: guard,
        meta: { permissions: ["financial.view"] }
      },

      {
        path: "/administradores",
        name: "AdminList",
        component: AdminList,
        beforeEnter: guard,
        meta: { permissions: ["admins.view"] }
      },
      {
        path: "/administradores/:id",
        name: "AdminDetails",
        component: AdminDetails,
        beforeEnter: guard,
        meta: { permissions: ["admins.find", "admins.update", "admins.create"] }
      },

      {
        path: "/papeis",
        name: "RolesList",
        component: RolesList,
        beforeEnter: guard,
        meta: { permissions: ["roles.view"] }
      },
      {
        path: "/papeis/:id",
        name: "RolesDetails",
        component: RolesDetails,
        beforeEnter: guard,
        meta: { permissions: ["roles.find", "roles.update", "roles.create"] }
      },

      {
        path: "/administradores",
        name: "AdminList",
        component: AdminList,
        beforeEnter: guard,
        meta: { permissions: ["admins.view"] }
      },
      {
        path: "/administradores/:id",
        name: "AdminDetails",
        component: AdminDetails,
        beforeEnter: guard,
        meta: { permissions: ["admins.find", "admins.update", "admins.create"] }
      },

      {
        path: "/monitoramento",
        name: "Trips",
        component: ServiceList,
        beforeEnter: guard,
        meta: { permissions: ["trips.view"] }
      },

      {
        path: "/itinerarios",
        name: "ItineraryList",
        component: ItineraryList,
        meta: { permissions: ["itineraries.view"] }
      },
      {
        path: "/itinerarios/:id",
        name: "ItineraryDetails",
        component: ItineraryDetails,
        beforeEnter: guard,
        meta: { permissions: ["itineraries.find", "itineraries.update", "itineraries.create"] }
      },

      {
        path: "/intervalos",
        name: "IntervalList",
        component: IntervalList,
        beforeEnter: guard,
        meta: { permissions: ["intervals.view"] }
      },
      {
        path: "/intervalos/:id",
        name: "IntervalDetails",
        component: IntervalDetails,
        beforeEnter: guard,
        meta: { permissions: ["intervals.find", "intervals.update", "intervals.create"] }
      },

      {
        path: "/pedagios",
        name: "TollList",
        component: TollList,
        beforeEnter: guard,
        meta: { permissions: ["tolls.view"] }
      },
      {
        path: "/pedagios/novo",
        name: "TollCreate",
        component: TollCreate,
        beforeEnter: guard,
        meta: { permissions: ["tolls.create"] }
      },
      {
        path: "/pedagios/editar/:id",
        name: "TollEdit",
        component: TollEdit,
        beforeEnter: guard,
        meta: { permissions: ["tolls.update"] }
      },

      {
        path: "/recorrencias",
        name: "TripRecurrenceList",
        component: TripRecurrenceList,
        beforeEnter: guard,
        meta: { permissions: ["recurrences.view"] }
      },

      {
        path: "/recorrencias/:id",
        name: "TripRecurrenceDetails",
        component: TripRecurrenceDetails,
        beforeEnter: guard,
        meta: { permissions: ["recurrences.view"] }
      },

      {
        path: "/empresas",
        name: "CustomerList",
        component: CustomerList,
        beforeEnter: guard,
        meta: { permissions: ["customers.view"] }
      },
      {
        path: "/empresas/:id",
        name: "CustomerDetails",
        component: CustomerDetails,
        beforeEnter: guard,
        meta: { permissions: ["customers.find", "customers.update", "customers.create"] }
      },

      {
        path: "/solicitantes",
        name: "RequesterList",
        component: RequesterList,
        beforeEnter: guard,
        meta: { permissions: ["requesters.view"] }
      },
      {
        path: "/solicitantes/:id",
        name: "RequesterDetails",
        component: RequesterDetails,
        beforeEnter: guard,
        meta: { permissions: ["requesters.find", "requesters.update", "requesters.create"] }
      },

      {
        path: "/passageiros",
        name: "PassengerList",
        component: PassengerList,
        beforeEnter: guard,
        meta: { permissions: ["passengers.view"] }
      },
      {
        path: "/passageiros/:id",
        name: "PassengerDetails",
        component: PassengerDetails,
        beforeEnter: guard,
        meta: { permissions: ["passengers.find", "passengers.update", "passengers.create"] }
      },

      {
        path: "/passageiros-lote",
        name: "PassengerImportList",
        component: PassengerImportList,
        beforeEnter: guard,
        meta: { permissions: ["passenger-imports.view"] }
      },
      {
        path: "/passageiros-lote/:id",
        name: "PassengerImportDetails",
        component: PassengerImportDetails,
        beforeEnter: guard,
        meta: { permissions: ["passenger-imports.find", "passenger-imports.create", "passenger-imports.view"] }
      },

      {
        path: "/locais",
        name: "LocationList",
        component: LocationList,
        beforeEnter: guard,
        meta: { permissions: ["locations.view"] }
      },
      {
        path: "/locais/:id",
        name: "LocationDetails",
        component: LocationDetails,
        beforeEnter: guard,
        meta: { permissions: ["locations.find", "locations.update", "locations.create"] }
      },

      {
        path: "/bairros",
        name: "DistrictLocationList",
        component: DistrictLocationList,
        beforeEnter: guard,
        meta: { permissions: [] }
      },
      {
        path: "/bairros/:id",
        name: "DistrictLocationDetails",
        component: DistrictLocationDetails,
        beforeEnter: guard,
        meta: { permissions: [] }
      },

      {
        path: "/feriados",
        name: "HolidaysList",
        component: HolidaysList,
        beforeEnter: guard,
        meta: { permissions: ["holidays.view"] }
      },
      {
        path: "/feriados/:id",
        name: "HolidaysDetails",
        component: HolidaysDetails,
        beforeEnter: guard,
        meta: { permissions: ["holidays.find", "holidays.update", "holidays.create"] }
      },

      {
        path: "/centro-custo",
        name: "CostCenterList",
        component: CostCenterList,
        beforeEnter: guard,
        meta: { permissions: ["costcenters.view"] }
      },
      {
        path: "/centro-custo/:id",
        name: "CostCenterDetails",
        component: CostCenterDetails,
        beforeEnter: guard,
        meta: { permissions: ["costcenters.find", "costcenters.update", "costcenters.create"] }
      },

      {
        path: "/veiculos",
        name: "VehicleList",
        component: VehicleList,
        beforeEnter: guard,
        meta: { permissions: ["vehicles.view"] }
      },
      {
        path: "/marcas-modelos",
        name: "VehicleCatalog",
        component: VehicleCatalog,
        beforeEnter: guard,
        meta: { permissions: ["vehicles.view"] }
      },
      {
        path: "/veiculos/:id",
        name: "VehicleDetails",
        component: VehicleDetails,
        beforeEnter: guard,
        meta: { permissions: ["vehicles.find", "vehicles.update", "vehicles.create"] }
      },
      {
        path: "/abastecimentos",
        name: "SuppliesList",
        component: SuppliesList,
        beforeEnter: guard,
        meta: { permissions: ["vehicles.view"] }
      },
      {
        path: "/abastecimentos/:id",
        name: "SuppliesDetails",
        component: SuppliesDetails,
        beforeEnter: guard,
        meta: { permissions: ["vehicles.view"] }
      },

      // =====================
      // LOGÍSTICA / MOTORISTAS
      // =====================
      {
        path: "/logistica",
        name: "LogisticsList",
        component: LogisticsList,
        beforeEnter: guard,
        meta: { permissions: ["logistics.view"] }
      },
      {
        path: "/logistica/importar",
        name: "LogisticsImport",
        component: LogisticsImport,
        beforeEnter: guard,
        meta: { permissions: ["logistics.view"] }
      },

      {
        path: "/motoristas",
        name: "DriversList",
        component: DriverList,
        meta: { permissions: ["drivers.view"] }
      },
      {
        path: "/motoristas/:id",
        name: "DriversDetails",
        component: DriverDetails,
        beforeEnter: guard,
        meta: { permissions: ["drivers.find", "drivers.update", "drivers.create"] }
      },

      {
        path: "/manutencoes",
        name: "Maintenances",
        component: PreventiveList,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/preventiva/novo",
        name: "PreventiveMaintenanceDetails",
        component: PreventiveMaintenanceDetails,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/programacoes",
        name: "MaintenanceSchedulings",
        component: PreventiveSchedulingList,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/programacoes/:id",
        name: "PreventiveSchedulingDetails",
        component: PreventiveSchedulingDetails,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/corretivas",
        name: "CorrectiveMaintenances",
        component: CorrectiveList,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/corretivas/:id",
        name: "CorrectiveDetails",
        component: CorrectiveDetails,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/estoque",
        name: "MaintenancePartStock",
        component: PartStockList,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/estoque/:id",
        name: "PartStockDetails",
        component: PartStockDetails,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/fornecedores",
        name: "Suppliers",
        component: SupplierList,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },
      {
        path: "/manutencoes/fornecedores/:id",
        name: "SupplierDetails",
        component: SupplierDetails,
        beforeEnter: guard,
        meta: { permissions: ["maintenances.view"] }
      },

      {
        path: "/auditoria",
        name: "AuditList",
        component: AuditList,
        beforeEnter: guard,
        meta: { permissions: ["audits.view"] }
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
